/**
 * GuideModal.js
 * "System Tune-up" Modal with Glassmorphism
 */
import { renderIcon } from '../../utils/icons.js';
import { locale } from '../../services/LocaleService.js';

export class GuideModal {
    constructor() {
        this.render();
    }

    render() {
        if (document.getElementById('guide-modal-overlay')) return;

        // Dark Glass Overlay
        // Dark Glass Overlay (Layer 1: Behind Header)
        const overlay = document.createElement('div');
        overlay.id = 'guide-modal-overlay';
        overlay.className = "fixed inset-0 bg-black/50 z-[9990] transition-opacity opacity-0 backdrop-blur-sm";
        overlay.style.backgroundColor = "rgba(0, 0, 0, 0.7)";
        overlay.style.backdropFilter = "blur(10px)";
        overlay.style.webkitBackdropFilter = "blur(10px)";

        // Wrapper (Layer 2: Top of Everything, Pointer Events None)
        const wrapper = document.createElement('div');
        wrapper.className = "fixed inset-0 z-[10001] flex items-center justify-center pointer-events-none";

        // Modal Box (Clickable)
        const modal = document.createElement('div');
        modal.className = "bg-white dark:bg-zinc-900 rounded-2xl shadow-xl w-[90%] max-w-md overflow-hidden transform scale-95 opacity-0 transition-all duration-300 relative pointer-events-auto p-8 flex flex-col items-center justify-center text-center";
        modal.onclick = (e) => e.stopPropagation();
        modal.style.background = "linear-gradient(rgba(0, 0, 0, 0.8), rgba(0, 0, 0, 0.8)), url('/favicon.webp')";
        modal.style.backgroundSize = "cover";
        modal.style.backgroundPosition = "center";
        modal.style.border = "1px solid rgba(255, 255, 255, 0.1)";
        modal.style.borderRadius = "20px";
        modal.style.boxShadow = "0 8px 32px 0 rgba(0, 0, 0, 0.37)";

        // Icon (Pulse Animation)
        const iconWrapper = document.createElement('div');
        iconWrapper.className = "mb-6 text-white animate-pulse";
        renderIcon(iconWrapper, 'Compass', { class: "w-16 h-16", "stroke-width": 1.5 });

        // Title
        const title = document.createElement('h3');
        title.className = "text-xl font-bold text-white mb-2";
        title.innerText = locale.t('guide.title'); // "시스템 조율 중"

        // Subtitle (English)
        const subtitle = document.createElement('p');
        subtitle.className = "text-xs text-white/50 uppercase tracking-widest mb-6 font-medium";
        subtitle.innerText = "Under Construction";

        // Message
        const message = document.createElement('p');
        message.className = "text-sm text-gray-300 mb-8 leading-relaxed";
        message.innerHTML = `${locale.t('guide.desc')}<br><br><span class='text-xs text-gray-500'>${locale.t('guide.wait')}</span>`;

        // Button
        const confirmBtn = document.createElement('button');
        confirmBtn.className = "px-8 py-2.5 bg-white/10 hover:bg-white/20 border border-white/10 rounded-full text-white text-sm transition-all hover:scale-105 active:scale-95";
        confirmBtn.innerText = locale.t('common.confirm'); // "확인"

        // Assembly
        modal.appendChild(iconWrapper);
        modal.appendChild(title);
        modal.appendChild(subtitle);
        modal.appendChild(message);
        modal.appendChild(confirmBtn);

        wrapper.appendChild(modal);
        document.body.appendChild(overlay);
        document.body.appendChild(wrapper);

        this.overlay = overlay;
        this.wrapper = wrapper;
        this.modal = modal;

        // Animate In
        requestAnimationFrame(() => {
            overlay.classList.remove('opacity-0');
            modal.classList.remove('scale-95', 'opacity-0');
            modal.classList.add('scale-100', 'opacity-100');
        });

        // Events
        const close = () => {
            overlay.classList.add('opacity-0');
            modal.classList.remove('scale-100', 'opacity-100');
            modal.classList.add('scale-95', 'opacity-0');
            setTimeout(() => {
                if (overlay.isConnected) overlay.remove();
                if (wrapper.isConnected) wrapper.remove();
            }, 300);
        };

        confirmBtn.onclick = close;
        overlay.onclick = () => close();
    }
}
